document.addEventListener("DOMContentLoaded", function() {

    const buttons = document.querySelectorAll('.checkout');
    
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        button.classList.add('loading');
    
        setTimeout(() => {
          button.classList.remove('loading');
        }, 2000);
      });
    });

  const subscribe_button = document.querySelector('#subscriptionConvert');

    subscribe_button.addEventListener('click', () => {
      subscribe_button.classList.add('loading');
    
      setTimeout(() => {
        subscribe_button.classList.remove('loading');
      }, 2000);
    });
     // document.getElementById("openPopupBtn").addEventListener("click", function() {
     //      document.getElementById("popup").classList.add("active");
     //  });

  document.getElementById("subscriptionConvert").addEventListener("click", function() {
     document.getElementById("popup").classList.remove("active");
    const checkboxes = document.querySelectorAll(".subscription_select");
    
    checkboxes.forEach(checkbox => {
      checkbox.checked = true; // Checks the checkbox
      checkbox.dispatchEvent(new Event('change')); // Triggers change event if needed
    });
    document.querySelectorAll('#build-your-own-bundle .checkout').forEach(button => {
      button.textContent = 'Subscribe Now';
    });

    if(window.innerWidth >= 1200){
         document.querySelector('.bundle_cta.desktop button').click();
      }else{
        document.querySelector('.mobile_responsive_popup button').click();  
      }
  });
  document.getElementById("closepopup").addEventListener("click", function() {
    popup_close = false;
    document.getElementById("popup").classList.remove("active");
     if(window.innerWidth >= 1200){
         document.querySelector('.bundle_cta.desktop button').click();
      }else{
        document.querySelector('.mobile_responsive_popup button').click();  
      }
  });

   function saveToLocalStorage(item) {
     let bundleList = JSON.parse(localStorage.getItem("bundleList")) || [];
     bundleList.push(item); // Add new item one by one
     localStorage.setItem("bundleList", JSON.stringify(bundleList));

     updatePlaceholderImages();
     updateButtonStates();
     updateCheckout();
   }

   function removeFromLocalStorage(productImage) {
     let bundleList = JSON.parse(localStorage.getItem("bundleList")) || [];

     // Remove only the last added occurrence of the product
     for (let i = bundleList.length - 1; i >= 0; i--) {
       if (bundleList[i].image === productImage) {
         bundleList.splice(i, 1); // Remove the last added occurrence
         break;
       }
     }

     localStorage.setItem("bundleList", JSON.stringify(bundleList));
     updateCheckout();
   }
  
   function getTotalSelectedQuantity() {
     let bundleItems = JSON.parse(localStorage.getItem("bundleList")) || [];
     return bundleItems.length; // Total number of selected items in bundle
   }

   function calculateTotalPrice() {
     let discount_codes = {
       '5': {
         code: 'SMALL_BUNDLE',
         amount: '25'
       },
       '9': {
         code: 'MEDIUM_BUNDLE',
         amount: '50'
       },
       '12': {
         code: 'BIG_BUNDLE',
         amount: '100'
       }
     };

     let totalPrice = 0;
     let totalComparePrice = 0;

     // Get the selected pack size
     let packSize = Number(document.querySelector("input[name='pack']:checked")?.value) || 0;

     // Calculate total price based on selected items
     document.querySelectorAll(".bundle-product").forEach(item => {
      
       let qtyInput = item.querySelector(".quantity-input"); // Assuming quantity input has this class
      var comparePrice = parseFloat(qtyInput.getAttribute("data-variant-price")) || 0;
       if(window.innerWidth >= 1200){
        if(document.querySelector('#BundlePlan').checked){
          var price = parseFloat(qtyInput.getAttribute("data-variant-subscription-price")) || 0;
        }else{
          var price = parseFloat(qtyInput.getAttribute("data-variant-price")) || 0;
        }
      }else{
        if(document.querySelector('#test2').checked){
          var price = parseFloat(qtyInput.getAttribute("data-variant-subscription-price")) || 0;
        }else{
          var price = parseFloat(qtyInput.getAttribute("data-variant-price")) || 0;
        }
      }
       
       
       
       let qty = parseInt(qtyInput.value, 10) || 0;
       totalPrice += price * qty;
       totalComparePrice += comparePrice*qty
     });

     // Get the discount amount based on pack size
     let discountAmount = discount_codes[packSize]?.amount ? Number(discount_codes[packSize].amount) : 0;


     // Calculate the final price after discount
     let finalPrice = Math.max(totalPrice - discountAmount, 0); // Ensure final price is not negative

     // Format numbers to remove .00 if whole number
     let formatPrice = (price) => (price % 1 === 0 ? price.toFixed(0) : price.toFixed(2));
      // let new_final = formatPrice(finalPrice)*0.75;
     // Update UI elements (Assuming the IDs exist)
     document.getElementById("compare-price").textContent = '$' + formatPrice(totalComparePrice); // Original Price
     document.getElementById("sub-total-price").textContent = '$' + formatPrice(finalPrice); // Final Price after discount
   }

   function updateCheckout() {
     let selectedPackSize = Number(document.querySelector("input[name='pack']:checked")?.value) || 0;
     const addToBundleBtn = document.querySelector(".checkout");
     const addToBundleBtnMobile = document.querySelector(".button_with_data.bundle_cta .checkout");

     // Get bundle items from localStorage
     let bundleItems = JSON.parse(localStorage.getItem("bundleList")) || [];

     let totalSelected = bundleItems.length; // Count number of added items
     let remaining = selectedPackSize - totalSelected;

     if (selectedPackSize === 0) {
       // No pack selected, disable button & show default message
       addToBundleBtn.textContent = `Pick a pack size`;
       addToBundleBtn.disabled = true;
       addToBundleBtnMobile.textContent = `Pick a pack size`;
       addToBundleBtnMobile.disabled = true;
       return;
     }
     
    // const subscribeRadio = document.querySelector(
    //   'input.subscription_select[value="subscriptions"]'
    // );
    // const oneTimeRadio = document.querySelector(
    //   'input.subscription_select[value="onetime"]'
    // );
    // console.log(subscribeRadio, 'subscribeRadiosubscribeRadio')

    //  if (remaining > 0) {
    //    // Show remaining slots & disable button
    //    addToBundleBtn.textContent = `Pick ${remaining} more Items`;
    //    addToBundleBtn.disabled = true;
    //    addToBundleBtnMobile.textContent = `Pick ${remaining} more Items`;
    //    addToBundleBtnMobile.disabled = true;
    //  } else {
    //    // Enable button when all slots are filled
    //   //  addToBundleBtn.textContent = "ADD TO CART";
    //   //  addToBundleBtn.disabled = false;
    //   //  addToBundleBtnMobile.textContent = "ADD TO CART";
    //   //  addToBundleBtnMobile.disabled = false;
    //   if (subscribeRadio && subscribeRadio.checked) {
    //     addToBundleBtn.textContent = "SUBSCRIBE NOW";
    //     addToBundleBtn.disabled = false;
    //     addToBundleBtnMobile.textContent = "SUBSCRIBE NOW";
    //     addToBundleBtnMobile.disabled = false;
    //   } else {
    //     // Default = One Time Purchase
    //     addToBundleBtn.textContent = "ADD TO CART";
    //     addToBundleBtn.disabled = false;
    //     addToBundleBtnMobile.textContent = "ADD TO CART";
    //     addToBundleBtnMobile.disabled = false;
    //   }
    //  }
    const subscribeRadios = document.querySelectorAll(
  'input.subscription_select[value="subscriptions"]'
);

const oneTimeRadios = document.querySelectorAll(
  'input.subscription_select[value="onetime"]'
);
// helper function to check if ANY subscribe radio is checked
function isSubscribeChecked() {
  return Array.from(subscribeRadios).some(radio => radio.checked);
  
}

if (remaining > 0) {
  // Show remaining slots & disable button
  addToBundleBtn.textContent = `Pick ${remaining} more Items`;
  addToBundleBtn.disabled = true;

  addToBundleBtnMobile.textContent = `Pick ${remaining} more Items`;
  addToBundleBtnMobile.disabled = true;
} else {
  // All slots filled
  if (isSubscribeChecked()) {
    addToBundleBtn.textContent = "SUBSCRIBE NOW";
    addToBundleBtn.disabled = false;

    addToBundleBtnMobile.textContent = "SUBSCRIBE NOW";
    addToBundleBtnMobile.disabled = false;
  } else {
    // Default = One Time Purchase
    addToBundleBtn.textContent = "ADD TO CART";
    addToBundleBtn.disabled = false;

    addToBundleBtnMobile.textContent = "ADD TO CART";
    addToBundleBtnMobile.disabled = false;
  }
}


     let mobile_count = '(' + totalSelected + '/' + selectedPackSize + ')'
     document.querySelector('.mobile_responsive_popup span b').textContent = mobile_count;
     totalSelected
   }

   function updateButtonStates() {
     let selectedPackLimit = Number(document.querySelector("input[name='pack']:checked").value);
     const totalSelected = getTotalSelectedQuantity();
     document.querySelectorAll(".btn-add-to-bundle").forEach(button => {
       button.disabled = totalSelected >= selectedPackLimit;
     });
     calculateTotalPrice();
   }

   function adjustSelectionForPackSize(packSize) {
     let bundleItems = JSON.parse(localStorage.getItem("bundleList")) || [];
     let selectedImages = bundleItems.map(item => item.image); // Get selected images from localStorage

     // Count occurrences of each image
     let imageCounts = {};
     selectedImages.forEach(image => {
       imageCounts[image] = (imageCounts[image] || 0) + 1;
     });

     // Reset all quantities to 0 first
     document.querySelectorAll(".bundle-product").forEach(bundle => {
       const quantityInput = bundle.querySelector(".quantity-input");
       const quantityContainer = bundle.querySelector(".quantity-container");
       const addButton = bundle.querySelector(".btn-add-to-bundle");
       const productImage = bundle.querySelector(".bundle_image").src;

       let newQuantity = imageCounts[productImage] || 0; // Get count of this image

       if (newQuantity > 0) {
         // If the product is in the bundle list, update the quantity
         quantityInput.value = newQuantity;
         quantityContainer.style.display = "flex"; // Show the quantity picker
         addButton.style.display = "none"; // Hide "+ Add" button
         bundle.classList.add('active');
       } else {
         // If not in bundle list, hide the entire product
         quantityContainer.style.display = "none";
         addButton.style.display = "inline-block"; // Show "+ Add" button
         bundle.classList.remove('active');
       }
     });

     // Manage placeholders based on the selected pack size
     let placeholders = document.querySelectorAll(".placeholder");

     placeholders.forEach((placeholder, index) => {
       let img = placeholder.querySelector("img");
       let placeholderURL = placeholder.querySelector("figure").getAttribute("data-placeholder");

       if (index < packSize) {
         placeholder.style.display = "block"; // Show required placeholders
       } else {
         placeholder.style.display = "none"; // Hide extra placeholders
         if (img) {
           img.src = placeholderURL; // Reset placeholder image
         }
       }
     });

     updatePlaceholderImages();
     updateButtonStates();
   }

   function updatePlaceholderImages() {
     const placeholders = document.querySelectorAll(".placeholder figure");
     let bundleItems = JSON.parse(localStorage.getItem("bundleList")) || []; // Get items from localStorage

     // Clear all placeholders first
     placeholders.forEach((figure, index) => {
       figure.innerHTML = ""; // Reset placeholders
       figure.parentElement.classList.remove("filled");

       // Restore default placeholder image
       let placeholderSrc = figure.getAttribute("data-placeholder");
       let img = document.createElement("img");
       img.src = placeholderSrc;
       // img.style.width = "100px";
       // img.style.margin = "5px";
       figure.appendChild(img);
     });

     // Fill placeholders with stored bundle items
     bundleItems.forEach((item, index) => {
       if (index < placeholders.length) {
         let figure = placeholders[index];
         figure.innerHTML = ""; // Clear before adding new product
         figure.parentElement.classList.add("filled");

         // Create product image
         let img = document.createElement("img");
         img.src = item.image; // Get image from localStorage
         // img.style.width = "100px";
         // img.style.margin = "5px";

         // Create close (X) button
         let closeIcon = document.createElement("span");
         closeIcon.innerHTML = "&#10006;"; // Close symbol
         closeIcon.style.position = "absolute";
         closeIcon.style.top = "5px";
         closeIcon.style.width = "24px";
         closeIcon.style.height = "24px";
         closeIcon.style.left = "-3px";
         closeIcon.style.background = "#3C525A";
         closeIcon.style.color = "white";
         closeIcon.style.fontSize = "12px";
         closeIcon.style.cursor = "pointer";
         closeIcon.style.textAlign = "center";
         closeIcon.style.padding = "0px 5px";
         closeIcon.style.borderRadius = "50%";
         closeIcon.setAttribute("data-count", index);


         // Remove item from localStorage when close button is clicked
         closeIcon.addEventListener("click", function() {
           removeImageFromPlaceholder(item.image, index);
         });

         // Append image & close button to placeholder
         figure.appendChild(img);
         figure.appendChild(closeIcon);
       }
     });

     updateButtonStates(); // Update button states based on new items
     updateCheckout();
   }

   function removeImageFromPlaceholder(imageSrc, index) {

     let bundleItems = JSON.parse(localStorage.getItem("bundleList")) || [];

     // Remove the item at the given index
     if (index >= 0 && index < bundleItems.length) {
       bundleItems.splice(index, 1);
       localStorage.setItem("bundleList", JSON.stringify(bundleItems)); // Update localStorage
     }

     document.querySelectorAll(".placeholder figure img").forEach(img => {
       if (img.src === imageSrc) {
         const figure = img.parentElement;
         figure.innerHTML = ""; // Clear both image and close icon
       }
     });

     // Update the corresponding product quantity
     document.querySelectorAll(".bundle-product").forEach(bundle => {
       const productImage = bundle.querySelector(".bundle_image").src;
       const quantityInput = bundle.querySelector(".quantity-input");
       const quantityContainer = bundle.querySelector(".quantity-container");
       const addButton = bundle.querySelector(".btn-add-to-bundle");

       if (productImage === imageSrc) {
         let currentValue = parseInt(quantityInput.value, 10);

         if (currentValue > 0) {
           quantityInput.value = currentValue - 1;
         }
         if (parseInt(quantityInput.value, 10) === 0) {
           quantityContainer.style.display = "none"; // Hide quantity picker
           addButton.style.display = "inline-block"; // Show "+ Add" button
           // addButton.classList.remove('active');
           bundle.classList.remove('active');
         }
       }
     });

     updatePlaceholderImages(); // Refresh placeholders after removal
     updateButtonStates(); // Re-enable "+ Add" if needed
     updateCheckout();
   }

   function loadBundleItemsMobile() {
     let bundleItems = JSON.parse(localStorage.getItem("bundleList")) || []; // Get items from local storage
     let parentContainer = document.querySelector(".mobile_res_row"); // Get parent container

     if(bundleItems.length < 1){
       document.querySelector('.mobile_responsive_popup').style.display = "none";
     }else{
       document.querySelector('.mobile_responsive_popup').style.display = "block";
     }
     // Clear existing items to prevent duplicates
     parentContainer.innerHTML = "";

     bundleItems.forEach((item, index) => {
       let itemDiv = document.createElement("div");
       itemDiv.classList.add("mobile_res_col");

       itemDiv.innerHTML = `
              <span class="remove-item" data-index="${index}" 
                  style="position: absolute; top: -2px; width: 20px; height: 20px; 
                  left: 3px; background: rgb(60, 82, 90); color: #fff!important; font-size: 10px; 
                  cursor: pointer; text-align: center; padding: 0px 5px; border-radius: 50%;"><span class="remove-item">
  <svg viewBox="0 0 24 24" width="12" height="12" fill="#fff">
    <path d="M18 6L6 18M6 6l12 12" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
  </svg>
</span></span>
  
              <img class="bundle_image" src="${item.image}" width="300" height="300" 
                  alt="${item.name}" loading="lazy">
          `;

       parentContainer.appendChild(itemDiv);
     });

     // Add event listeners to remove items when clicking the "✖" button
     document.querySelectorAll(".remove-item").forEach(button => {
       button.addEventListener("click", function() {
         let imgsrc = this.nextElementSibling.src;
         let indexToRemove = this.getAttribute("data-index");
         removeBundleItem(imgsrc, indexToRemove);
       });
     });
   }

   function removeBundleItem(image_url, index) {
     let bundleItems = JSON.parse(localStorage.getItem("bundleList")) || [];
     bundleItems.splice(index, 1); // Remove the selected item
     localStorage.setItem("bundleList", JSON.stringify(bundleItems)); // Update local storage


     document.querySelectorAll(".bundle-product").forEach(bundle => {
       const productImage = bundle.querySelector(".bundle_image").src;
       const quantityInput = bundle.querySelector(".quantity-input");
       const quantityContainer = bundle.querySelector(".quantity-container");
       const addButton = bundle.querySelector(".btn-add-to-bundle");

       if (productImage === image_url) {
         let currentValue = parseInt(quantityInput.value, 10);
         if (currentValue == 1) {}
         if (currentValue > 0) {
           quantityInput.value = currentValue - 1;
         }

         if (parseInt(quantityInput.value, 10) === 0) {
           bundle.classList.remove('active');
           quantityContainer.style.display = "none"; // Hide quantity picker
           addButton.style.display = "inline-block"; // Show "+ Add" button
         }
       }
     });
     updatePlaceholderImages();
     loadBundleItemsMobile(); // Reload the updated list
     updateCheckout();

   }

  function getSellingPlanId(variantId, sellingPlanName) {
    if (!window.subscription_plans || window.subscription_plans.length === 0) {
        console.warn("No subscription plans found.");
        return null;
    }

    for (let i = 0; i < window.subscription_plans.length; i++) {
        let planData = window.subscription_plans[i];

        // Check if the variantId exists in this planData object
        if (planData.hasOwnProperty(variantId)) {
            let plans = planData[variantId];

            // Check if the selling plan name exists and return its ID
            if (plans.hasOwnProperty(sellingPlanName)) {
                return plans[sellingPlanName];
            }
        }
    }

    console.warn("Selling plan not found for variant:", variantId, "and plan name:", sellingPlanName);
    return null;
}

   function AddToCart(item) {

     var find_selling_plans = false;
     document.querySelector('#loaderOverlay').classList.add('active');
     if(window.innerWidth >= 1200){
      if(document.querySelector('#BundlePlan').checked){
       var find_selling_plans = true;
       
       if(window.innerWidth >= 1200){
          var selected_plan = document.querySelector('.subscription_plans.desktop').value;      
       }else{
          var selected_plan = document.querySelector('.subscription_plans.mobile').value;            
       }
     }  
     }else{
      if(document.querySelector('#test2').checked){
       var find_selling_plans = true;
       
       if(window.innerWidth >= 1200){
          var selected_plan = document.querySelector('.subscription_plans.desktop').value;      
       }else{
          var selected_plan = document.querySelector('.subscription_plans.mobile').value;            
       }
     }
     }
    //  if(document.querySelector('#BundlePlan').checked){
    //    var find_selling_plans = true;
       
    //    if(window.innerWidth >= 1200){
    //       var selected_plan = document.querySelector('.subscription_plans.desktop').value;      
    //    }else{
    //       var selected_plan = document.querySelector('.subscription_plans.mobile').value;            
    //    }
    //  }
     let bundleitems = [];
     var total_qty = 0;
     document.querySelectorAll(".bundle-product").forEach(bundle => {
       const quantityInput = bundle.querySelector(".quantity-input");
       let currentValue = parseInt(quantityInput.value, 10);
      total_qty += currentValue;
       if (currentValue > 0) {
         let variantid = parseInt(quantityInput.getAttribute("data-variant-id"), 10); // Ensure it's a number
          if(find_selling_plans){
            let sellingPlanId = getSellingPlanId(variantid, selected_plan);
            if(sellingPlanId){
              bundleitems.push({
                 id: variantid,
                 quantity: currentValue,
                 properties: { "_bundle": "true" },
                selling_plan: sellingPlanId
             });
            }
          }else{
            bundleitems.push({
             id: variantid,
             quantity: currentValue,
             properties: { "_bundle": "true" } 
           });
          }
       }
     });

     console.log('Items to add: total_qty', total_qty);

     let discount_codes  = ['SMALL_BUNDLE', 'MEDIUM_BUNDLE', 'BIG_BUNDLE'];
     var applicable_discount = '';
     if(total_qty >= 12){
       applicable_discount = discount_codes[2];
     }else if(total_qty >= 9 ){
       applicable_discount = discount_codes[1];
     }else if(total_qty >= 5){
       applicable_discount = discount_codes[0];
     }
     if (bundleitems.length >= 0) {
       fetch('/cart/clear.js', {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json'
           }
         })
         .then(response => response.json())
         .then(() => {
           // console.log('Cart cleared');

           // Step 2: Add new items to the cart
           return fetch('/cart/add.js', {
             method: 'POST',
             headers: {
               'Content-Type': 'application/json'
             },
             body: JSON.stringify({
               items: bundleitems
             })
           });
         })
         .then(response => response.json())
         .then(data => {
           console.log('Items added:', data);
           document.querySelector('#loaderOverlay').classList.remove('active');
           // Step 3: Redirect to checkout with discount applied
           window.location.href = `/checkout?discount=${encodeURIComponent(applicable_discount)}`;
         })
         .catch(error => console.error('Error:', error));
     } else {
       console.log('No items to add.');
     }
   }

   let selectedPackLimit = Number(document.querySelector("input[name='pack']:checked").value);
   updatePlaceholderImages();
   loadBundleItemsMobile();

   // Update pack limit when a radio button is selected
   document.querySelectorAll("input[name='pack']").forEach(radio => {
     radio.addEventListener("change", function() {
       let selectedPackSize = parseInt(this.value, 10); // Get selected pack size
       let bundleItems = JSON.parse(localStorage.getItem("bundleList")) || [];
       let bundleSize = JSON.parse(localStorage.getItem("bundleSize")) || [];

       localStorage.setItem("bundleSize", selectedPackSize);
       // Remove extra items if new pack size is smaller
       if (bundleItems.length > selectedPackSize) {
         bundleItems = bundleItems.slice(0, selectedPackSize); // Keep only first X items
         localStorage.setItem("bundleList", JSON.stringify(bundleItems)); // Update storage
       }
       const selectedProducts = document.querySelector('.selected-products');

       // Remove existing classes before adding a new one
       selectedProducts.classList.remove('five', 'nine', 'twelve');

       if (selectedPackSize == '5') {
         selectedProducts.classList.add('five');
       } else if (selectedPackSize == '9') {
         selectedProducts.classList.add('nine');
       } else {
         selectedProducts.classList.add('twelve');
       }


       adjustSelectionForPackSize(selectedPackSize);
       updateCheckout();
       loadBundleItemsMobile();
     });
   });

   document.querySelectorAll(".btn-add-to-bundle").forEach(button => {
     button.addEventListener("click", function() {
       let selectedPackLimit = Number(document.querySelector("input[name='pack']:checked").value);
       if (getTotalSelectedQuantity() >= selectedPackLimit) {
         alert("Pack full! You cannot add more.");
         return;
       }

       // debugger;
       if (document.body.classList.contains("product_info")) {
         // popup code handle
         var productImage =  this.closest('.img_with_title').querySelector('img').src;
         const quantityContainer = this.nextElementSibling;
         const quantityInput = quantityContainer.querySelector(".quantity-input");
  
         quantityInput.value = 1; // Set initial quantity to 1
         // bundleProduct.classList.add('active');
         quantityContainer.style.display = "flex";
         this.style.display = "none"; // Hide "+ Add" button
        var index_zoom =  document.querySelector('.img_with_title').getAttribute('data-zoom-index');
        var zoomElementt = document.querySelector('.zoom[data-index="'+index_zoom+'"]');
         if (zoomElementt) {
          quantityInput.value = 1; // Set initial quantity to 1
          var bundleProduct = zoomElementt.closest('.bundle-product');
          var quantityContainer2 = bundleProduct.querySelector('.quantity-container');
          var quantityInput2 = quantityContainer2.querySelector(".quantity-input");
          quantityInput2.value = 1; // Set initial quantity to 1
          bundleProduct.classList.add('active');
          quantityContainer2.style.display = "flex";
          bundleProduct.querySelector('.btn-add-to-bundle').style.display = "none"; // Hide "+ Add" button
         }
         
      }else{
         var bundleProduct = this.closest(".bundle-product");  // if undefnied then popup image find
         var productImage = bundleProduct.querySelector(".bundle_image").src;
         const quantityContainer = bundleProduct.querySelector(".quantity-container");
         const quantityInput = quantityContainer.querySelector(".quantity-input");
  
         quantityInput.value = 1; // Set initial quantity to 1
         bundleProduct.classList.add('active');
         quantityContainer.style.display = "flex";
         this.style.display = "none"; // Hide "+ Add" button
      }

       

       saveToLocalStorage({
         image: productImage
       });
       updatePlaceholderImages();
       updateButtonStates();
       updateCheckout();
       loadBundleItemsMobile();
     });
   });

   document.querySelectorAll(".quantity-container").forEach(container => {
     const decreaseBtn = container.querySelector(".decrease-btn");
     const increaseBtn = container.querySelector(".increase-btn");
     const quantityInput = container.querySelector(".quantity-input");
     let bundleProduct = container.parentElement;
     // const productImage = container.closest(".bundle-product").querySelector(".bundle_image").src;  // Get product image
     var productImage = bundleProduct.querySelector(".bundle_image")?.src;  // Get product imagr


     decreaseBtn.addEventListener("click", function() {
        if (!this.parentElement.classList.contains('without-popup')) {
          // Handle popup qty selectors
          productImage = this.closest('.img_with_title').querySelector('img').src;
          var zoom_index = this.closest('.img_with_title').getAttribute("data-zoom-index");
          
          const zoomElement = document.querySelector('.zoom[data-index="'+zoom_index+'"]');
        
          if (zoomElement) {
              const bundleProduct = zoomElement.closest('.bundle-product');
              const quantityContainer = bundleProduct.querySelector('.quantity-container');
          
              if (quantityContainer) {
                  const increaseButton = quantityContainer.querySelector('.increase-btn');
                  const decreaseButton = quantityContainer.querySelector('.decrease-btn');
  
                decreaseButton.click();
              } else {
                  console.warn("No .quantity-container found within the closest .bundle-product.");
              }
          } else {
              console.warn("Element with .zoom[data-index='1'] not found.");
          }


          let currentValue = parseInt(quantityInput.value, 10);
           if (currentValue > 0) {
             quantityInput.value = currentValue - 1;
           }
    
           if (parseInt(quantityInput.value, 10) === 0) {
             container.style.display = "none"; // Hide quantity picker
             container.previousElementSibling.style.display = "inline-block"; // Show "+ Add" button
             // container.closest(".bundle-product").classList.remove('active');
             container.closest(".bundle-product")?.classList?.remove('active');
    
           }
           // updatePlaceholderImages();
           // updateButtonStates();
           // updateCheckout();
           // loadBundleItemsMobile();
        }else{
          //handle normal qty selector
          let currentValue = parseInt(quantityInput.value, 10);
           if (currentValue > 0) {
             quantityInput.value = currentValue - 1;
             removeFromLocalStorage(productImage);
           }
    
           if (parseInt(quantityInput.value, 10) === 0) {
             container.style.display = "none"; // Hide quantity picker
             container.previousElementSibling.style.display = "inline-block"; // Show "+ Add" button
             // container.closest(".bundle-product").classList.remove('active');
             container.closest(".bundle-product")?.classList?.remove('active');
    
           }
           updatePlaceholderImages();
           updateButtonStates();
           updateCheckout();
           loadBundleItemsMobile();
        }
       
     });

     increaseBtn.addEventListener("click", function() {
       let selectedPackLimit = Number(document.querySelector("input[name='pack']:checked").value);
       if (getTotalSelectedQuantity() >= selectedPackLimit) {
         alert("Pack full! You cannot add more.");
         return;
       }

       if (!this.parentElement.classList.contains('without-popup')) {

          productImage = this.closest('.img_with_title').querySelector('img').src;
          var zoom_index = this.closest('.img_with_title').getAttribute("data-zoom-index");
          
          const zoomElement = document.querySelector('.zoom[data-index="'+zoom_index+'"]');
        
          if (zoomElement) {
              const bundleProduct = zoomElement.closest('.bundle-product');
              const quantityContainer = bundleProduct.querySelector('.quantity-container');
          
              if (quantityContainer) {
                  const increaseButton = quantityContainer.querySelector('.increase-btn');
                  const decreaseButton = quantityContainer.querySelector('.decrease-btn');
  
                increaseButton.click();
              } else {
                  console.warn("No .quantity-container found within the closest .bundle-product.");
              }
          } else {
              console.warn("Element with .zoom[data-index='1'] not found.");
          }

         let currentValue = parseInt(quantityInput.value, 10);
         let maxValue = parseInt(quantityInput.max, 10);
  
         if (currentValue < maxValue) {
           quantityInput.value = currentValue + 1;
  
         }
         // var bundle_productImage = document.querySelector(".img_with_title img").src;  // Get Popup Image
       }else{
         let currentValue = parseInt(quantityInput.value, 10);
         let maxValue = parseInt(quantityInput.max, 10);
  
         if (currentValue < maxValue) {
           quantityInput.value = currentValue + 1;
  
         }
         const bundleProduct = this.closest(".bundle-product"); // Get the parent product container
         var bundle_productImage = bundleProduct.querySelector(".bundle_image").getAttribute("src"); // Get image URL

        saveToLocalStorage({
           image: bundle_productImage
         });
        updatePlaceholderImages();
         updateButtonStates();
         updateCheckout();
         loadBundleItemsMobile();
       }
      



     });

     quantityInput.addEventListener("input", function() {
       updatePlaceholderImages();
       updateButtonStates();
       updateCheckout();
     });
   });
  var popup_close = true;
   const checkoutButtons = document.querySelectorAll(".checkout");
    checkoutButtons.forEach(button => {
      button.addEventListener("click", function() {
        // debugger;
        if (!this.disabled) {
          if(window.innerWidth >= 1200){
            if(!document.querySelector('#BundlePlan').checked && popup_close){
              document.getElementById("popup").classList.add("active");
            }else{
              AddToCart(this);    
            }
          }else if(!document.querySelector('#test2').checked && popup_close){
            document.getElementById("popup").classList.add("active");
          }else{
            AddToCart(this);    
          }
          
        }
      });
    });

   let bundlesize = localStorage.getItem("bundleSize") || 5;

   if (bundlesize) {
     document.querySelector(`input[name='pack'][value='${bundlesize}']`).checked = true;
     adjustSelectionForPackSize(parseInt(bundlesize, 10));
     updateCheckout();

     const selectedProducts = document.querySelector('.selected-products');

     // Remove existing classes before adding a new one
     selectedProducts.classList.remove('five', 'nine', 'twelve');

     if (bundlesize == '5') {
       selectedProducts.classList.add('five');
     } else if (bundlesize == '9') {
       selectedProducts.classList.add('nine');
     } else {
       selectedProducts.classList.add('twelve');
     }
   }

   document.querySelectorAll(".toggleButton").forEach(button => {
     button.addEventListener("click", function() {
       let popup = document.querySelector(".mobile_responsive_popup");

       if (popup) {
         popup.classList.toggle("open"); 
       }
     });
   });
let justOpened = false;
   document.querySelectorAll(".zoom").forEach(button => {
      button.addEventListener("click", function () {
        
          justOpened = true; 
          let bundleProduct = this.closest(".bundle-product"); // Find the parent bundle-product
          let zoom_index = this.getAttribute("data-index"); // Find the parent bundle-product
          let widepopup =  this.getAttribute("data-wide-popup");
          var preview_image = bundleProduct.getAttribute('data-popup-image');
          var short_desc = bundleProduct.getAttribute('data-popup-title');
          var textture = bundleProduct.getAttribute('data-popup-textture');
          var textture_color = bundleProduct.getAttribute('data-popup-color');
          document.querySelector('#product_info_image').src = preview_image;
          document.querySelector('.right_content h4').textContent = textture;
          document.querySelector('.right_content h4').style.color = textture_color;

        if(widepopup == "true"){
          document.querySelector('.first_content').classList.add('wide')
        }else{
          document.querySelector('.first_content').classList.remove('wide')
        }
        
          var copy_html = bundleProduct.querySelector(".product_text .metafield-rich_text_field")?.outerHTML;
          let targetDiv = document.querySelector(".product_description_info"); 
          document.querySelector('.img_with_title').setAttribute('data-zoom-index', zoom_index);
          if (bundleProduct && targetDiv) {
            if (typeof copy_html !== "undefined") {
              targetDiv.innerHTML = copy_html;
            }else{
              targetDiv.innerHTML = '';
            }
              
          }
        if (document.querySelector('.right_content .metafield-rich_text_field p svg') != null){
          document.querySelector('.right_content .metafield-rich_text_field p svg').style.background = textture_color;
        }
          if (bundleProduct) {
              let productImage = bundleProduct.querySelector(".bundle_image")?.src || ""; // Get image src
              let productTitle = bundleProduct.querySelector("h5")?.textContent.trim() || ""; // Get h5 title
  
              document.querySelector("body").classList.add('product_info');

            document.querySelector('.img_with_title img').src =  productImage;
            document.querySelector('.right_content h2').textContent = productTitle
            
            var qty = bundleProduct.querySelector('.quantity-container .quantity-input-block').value;
            if(qty >= 1){
              document.querySelector('.add_with_quntity .cta-fill.btn-add-to-bundle').style.display = 'none';
              document.querySelector('.add_with_quntity .quantity-container').style.display = 'flex';
            }else{
              document.querySelector('.add_with_quntity .cta-fill.btn-add-to-bundle').style.display = 'block';
              document.querySelector('.add_with_quntity .quantity-container').style.display = 'none';
            }
            document.querySelector('.add_with_quntity .quantity-input-block').value = qty;
            
          } else {
              console.error("Error: .bundle-product not found for this zoom button");
          }
      });
  });

    document.addEventListener('click', function(event) {
        const popup = document.querySelector('.box_content'); // Replace with your actual popup wrapper
        const isPopupOpen = document.body.classList.contains('product_info');
    
        if (justOpened) {
            justOpened = false; // Reset the flag
            return;
        }
    
        if (isPopupOpen && popup && !popup.contains(event.target)) {
            document.body.classList.remove('product_info');
            console.log('Popup closed on outside click');
        }
    });
   document.querySelector(".close_popup").addEventListener("click", function () {
      let body = document.querySelector("body");
      
      body.classList.remove('product_info');
    });



  // Select all radio buttons with name="plan"
  const radios = document.querySelectorAll('input[name="radio-group-desktop"]');
  document.querySelectorAll('.sub-text').forEach(button => {
            button.style.display = 'none'
          });

  radios.forEach(radio => {
    radio.addEventListener("change", function () {
      if (this.checked) {
        const subscriptionPlans = document.querySelector('.subscription_plans.desktop');
        // debugger;
        if(this.value == "subscriptions"){
          
          if (subscriptionPlans) {
          subscriptionPlans.style.display = 'block';
          } else {  
            console.warn("No .subscription_plans found within the parent element.");
          }

          document.querySelectorAll('#build-your-own-bundle .checkout').forEach(button => {
            button.textContent = 'Subscribe Now';
          });
          document.querySelectorAll('.sub-text').forEach(button => {
            button.style.display = 'block'
          });
          document.querySelectorAll('.subscription_plans').forEach(function(e){
              e.value = e.options[e.options.length - 1].value;
          })
          calculateTotalPrice();    
        }else{
          document.querySelectorAll('#build-your-own-bundle .checkout').forEach(button => {
            button.textContent = 'Add To cart';
          });
          document.querySelectorAll('.sub-text').forEach(button => {
            button.style.display = 'none'
          });

          subscriptionPlans.style.display = 'none';
          calculateTotalPrice();    
        }
        
      }
    });
    
  });


  const radiosmobile = document.querySelectorAll('input[name="radio-group-mobile"]');
  document.querySelectorAll('.sub-text').forEach(button => {
            button.style.display = 'none'
          });

  radiosmobile.forEach(radio => {
    radio.addEventListener("change", function () {
      if (this.checked) {
        const subscriptionPlans = document.querySelector('.subscription_plans.mobile');
        // debugger;
        if(this.value == "subscriptions"){
          
          if (subscriptionPlans) {
          subscriptionPlans.style.display = 'block';
          } else {  
            console.warn("No .subscription_plans found within the parent element.");
          }

          document.querySelectorAll('#build-your-own-bundle .checkout').forEach(button => {
            button.textContent = 'Subscribe Now';
          });
          document.querySelectorAll('.sub-text').forEach(button => {
            button.style.display = 'block'
          });
          document.querySelectorAll('.subscription_plans').forEach(function(e){
              e.value = e.options[e.options.length - 1].value;
          });
          calculateTotalPrice();     
        }else{
          document.querySelectorAll('#build-your-own-bundle .checkout').forEach(button => {
            button.textContent = 'Add To cart';
          });
          document.querySelectorAll('.sub-text').forEach(button => {
            button.style.display = 'none'
          });

          subscriptionPlans.style.display = 'none';
          calculateTotalPrice();     
        }
       
      }
    });
    
  });
  
  // filter products code end
  document.querySelectorAll(".filter ul li").forEach(item => {
        item.addEventListener("click", function() {
            // Remove 'active' class from all filter items
            document.querySelectorAll(".filter ul li").forEach(li => li.classList.remove("active"));
    
            // Add 'active' class to the clicked filter
            this.classList.add("active");
    
            // Get the filter value from the clicked element
            let value = this.getAttribute("data-filter");
    
            // Call the function to filter products
            filterProducts(value);
            matchTitleHeights();
        });
    });
    
    function filterProducts(value) {
        document.querySelectorAll('.bundle-product').forEach(card => {
            let filterValue = card.getAttribute('data-filter');
    
            if (value === 'shop_all' || filterValue === value) {
                card.style.display = 'block'; // Show matching products
            } else {
                card.style.display = 'none'; // Hide non-matching products
            }
        });
        document.querySelectorAll('.collection-title').forEach(card => {
        let filterValue = card.getAttribute('data-filter');
        
        if (value === 'shop_all' || filterValue === value) {
            card.style.display = 'block'; // Show matching products
        } else {
            card.style.display = 'none'; // Hide non-matching products
        }
      });
    }
  // filter products code end
 });

function matchTitleHeights() {
  // Get all .bundle-inner containers
  const bundleInners = document.querySelectorAll('.bundle-inner');
  
  bundleInners.forEach(bundleInner => {
    // Get h5 elements within this specific .bundle-inner
    const titles = bundleInner.querySelectorAll('h5');
    let maxHeight = 0;

    // Reset heights to avoid accumulation on resize
    titles.forEach(title => title.style.height = 'auto');

    // Find the maximum height within this .bundle-inner
    titles.forEach(title => {
      if (title.offsetHeight > maxHeight) {
        maxHeight = title.offsetHeight;
      }
    });

    // Apply the maximum height to all h5 elements within this .bundle-inner
    titles.forEach(title => title.style.height = `${maxHeight}px`);
  });
}

 // Run on page load and window resize
 window.addEventListener('load', matchTitleHeights);
 window.addEventListener('resize', matchTitleHeights);